import React, { useState, useEffect } from 'react';
import { Link,useNavigate} from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../components/panel/panel.jsx';
import {API_BASE_URL} from "../../apiConfig.jsx";
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc';
import {strEncode,strDecode} from '../../encrpt';
import DataTable from 'react-data-table-component';
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";


function Usermanage() {
    const navigate = useNavigate();
	useEffect(() => {
		const authToken = localStorage.getItem("authToken");
        //console.log("authToken",authToken)
		if (!authToken) {
			localStorage.removeItem("user"); // Clear user data
			navigate(""); // Ensure correct redirection path
		}
	}, [navigate]);
	
	const [formData, setFormData] = useState({
		c_name: "",
		c_username: "",
		c_email: "",
		c_password: "",
		n_phone_no: "",
		n_user_type: "",
		n_status: "0",
		n_org_id :'',
		n_if_2fa_enabled : 0
	  });
	  
	
 const [errors, setErrors] = useState({});
 const [organizationtype, setOrganizationTypeList] = useState([]);
 const [usertype, setUserTypeList] = useState([]);
 const [internes, setRaporteeList] = useState([]);
 const [permissionmodules, setModulePermissionList] = useState([]);
 const [columns, setColumns] = useState([]);
 const [yesno, setYesNoList] = useState([]);
 const [tabledata, settableData] = useState([]);	
 const [selectedUser, setSelectedUser] = useState(null);
 const [editMode, setEditMode] = useState(false);
 const [modalData, setModalData] = useState(false);
 const [activeTab, setActiveTab] = useState("default-tab-1"); // Tracks active tab
 const [indiid, setModalId] = useState(null);	

 const [raporteedata, setRapporteeData] = useState({
	n_stakeholder_id : ""
  });

  const [permission, setPermissionData] = useState({
	n_master_id : ""
  });
  useEffect(() => {
	// Switch to "Ajouter un nouvel utilisateur" tab if edit mode is enabled
	if (editMode) {
	  setActiveTab("default-tab-2");
	//setEditMode(false)
	} else {
	  setActiveTab("default-tab-1");
	}
  }, [editMode]);

 
  useEffect(() => {
	axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_user_type_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setUserTypeList(res.data);
	  }).catch( (error) => { console.log(error); });
    

 
	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('stakeholder_reporting'),cols :strEncode("id,CONCAT(level_1, ' >> ', level_2, ' >> ', level_3, ' >> ', level_4) as c_name") ,whrc :strEncode("level_1 = 'RAPPORTS INTERNES'") },{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setRaporteeList(res.data);
	  }).catch( (error) => { console.log(error); });

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_modules_mst'),cols :strEncode("id,CONCAT(c_arabic_name, ' >> ', c_sub_cat_name) as c_name") ,whrc :strEncode("id > 0 and n_act_flg = 0 AND c_name <> 'Administration' order by n_sequence ASC") },{ headers: { 'Content-Type': 'application/json' } }) 
	.then( (res) => {
		setModulePermissionList(res.data);
	  }).catch( (error) => { console.log(error); });
	  

	    axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_yes_no_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
		.then( (res) => {
			setYesNoList(res.data);
		  }).catch( (error) => { console.log(error); });
	  

	  axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('v_pmis_user_mst'),
		cols:strEncode('*') },{ headers: { 'Content-Type': 'application/json' } }) 
				  .then( (res) => {					
					if (!res.data || !res.data || res.data.length === 0) {
						console.warn("Warning: API returned an empty or undefined response.");
						setColumns([]); // Reset columns
						settableData([]); // Reset table data
						return;
					}
					const columnKeys = Object.keys(res.data[0]);
					
					const formattedColumns = columnKeys.map((key) => ({
						name: key.charAt(0).toUpperCase() + key.slice(1),
						selector: row => row[key],
						sortable: true,
						cell: row => row[key] // Show normal column data
					  }));

					  formattedColumns.push({
						name: "فعل",
						cell: (row) => (
							<div>
						  <button className="btn btn-warning btn-sm" onClick={() => handleEdit(row)}>
						  تعديل
						  </button>
						   <button className="btn btn-danger btn-sm" data-bs-toggle="modal"
											data-bs-target="#modalPosBooking"
											onClick={() => handleModalOpen(row)}>
							ربط تقارير التنبيهات						  </button>
							<button className="btn btn-primary btn-sm" data-bs-toggle="modal"
											data-bs-target="#modalforUserpermission"
											onClick={() => handleModalUserPermission(row)}>
							تعيين إذن المستخدم					  </button>
							</div>
						),
					  });
					//console.log("columnKeys",columnKeys)
					setColumns(formattedColumns);
                    settableData(res.data);					
				  }).catch(error => {
					console.error("API Error:", error);
				  });
  }, []);
	
const tabActive = async (user) => {
	setFormData({
		c_name: "",
		c_username: "",
		c_email: "",
		c_password: "",
		n_phone_no: "",
		n_user_type: "",
		n_status: "",
		n_org_id :'',
		n_if_2fa_enabled : ''
	  });
  
	 setEditMode(false);
	 setSelectedUser(null);
}

const closeModal = () => {
	setModalData([]);
   }

   const handleMultiSelectChange = (event) => {
    const selectedOptions = Array.from(event.target.selectedOptions, (option) => option.value);
    setRapporteeData((prevData) => ({
         ...prevData,
         n_stakeholder_id: selectedOptions, // Store multiple values as an array
	     n_user : selectedUser.id
    }));
};


const handlePermissionChange = (event) => {
    const selectedOptions = Array.from(event.target.selectedOptions, (option) => option.value);
    setPermissionData((prevData) => ({
         ...prevData,
         n_master_id: selectedOptions, // Store multiple values as an array
	     n_user : selectedUser.id
    }));
};



  const handleEdit = async (user) => {
	//console.log("user.id",user.id)
	setSelectedUser(user);
	try {
	  const response = await axios.post(`${API_BASE_URL}/api/custom/selectall`, {
		t: strEncode('pmis_user_mst'),
		cols : 	strEncode('*'),	
		whrc : strEncode('id = '+user.id+''),
	  }, { headers: { 'Content-Type': 'application/json' } });
  
	 // console.log("getuserdata", response.data);
	 // setFormData(response.data[0]); // Assuming data comes as an array
	 setFormData({
		id : response.data[0].id,
		c_name: response.data[0].c_name,
		c_username: response.data[0].c_username,
		c_email: response.data[0].c_email,
		c_password: "",
		n_phone_no: response.data[0].n_phone_no,
		n_user_type: response.data[0].n_user_type,
		n_status: response.data[0].n_status,
        n_org_id : response.data[0].n_user_type > 0 ? "" : response.data[0].n_org_id,
		n_if_2fa_enabled : response.data[0].n_if_2fa_enabled
	  });

	} catch (error) {
	  console.error("Error fetching user data:", error);
	}
	setEditMode(true);
	setActiveTab("default-tab-2");
  };
  const handleModalOpen = async (user) => {
	//console.log("user.id",user.id)
	setSelectedUser(user);	
    setModalId(user.id)
	try {
        // Fetch existing user data (Assuming you retrieve `n_stakeholder_id` from API)
        const response = await axios.post(`${API_BASE_URL}/api/custom/selectall`, {
            t: strEncode('pmis_rapports_user_linking_mst'),
            cols: strEncode('n_stakeholder_id'),
            whrc: strEncode(`n_user = ${user.id}`),
        }, { headers: { 'Content-Type': 'application/json' } });
        //console.log("reasponse",response.data)
		if (response.data.length > 0) {
			setRapporteeData({
				n_stakeholder_id: response.data.map((item) => String(item.n_stakeholder_id)) // Ensure array of strings
			});
		} else {
			setRapporteeData({ n_stakeholder_id: [] }); // Default to empty array
		}
    } catch (error) {
        console.error("Error fetching stakeholder data:", error);
        setRapporteeData({ n_stakeholder_id: "" });
    }
  
  };

 const handleModalUserPermission = async (user) => {
	//console.log("user.id",user.id)
	setSelectedUser(user);	
    setModalId(user.id)
	try {
        // Fetch existing user data (Assuming you retrieve `n_stakeholder_id` from API)
        const response = await axios.post(`${API_BASE_URL}/api/custom/selectall`, {
            t: strEncode('pmis_user_perm_modules'),
            cols: strEncode('n_master_id'),
            whrc: strEncode(`n_user = ${user.id}`),
        }, { headers: { 'Content-Type': 'application/json' } });
        //console.log("reasponse",response.data)
		if (response.data.length > 0) {
			setPermissionData({
				n_master_id: response.data.map((item) => String(item.n_master_id)) // Ensure array of strings
			});
		} else {
			setPermissionData({ n_master_id: [] }); // Default to empty array
		}
    } catch (error) {
        console.error("Error fetching stakeholder data:", error);
        setPermissionData({ n_master_id: "" });
    }
  
  };
  

  
  

  const handleUpdate = async () => {
    if (!formData.id) {
      alert("Invalid User ID!");
      return;
    }
    try {
      await axios.put(`${API_BASE_URL}/api/user/update/${formData.id}`, formData);
      alert("User details updated successfully!");
      setEditMode(false);
      setSelectedUser(null);
      //window.location.reload(); // Refresh DataTable
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };



    // console.log("usertyoe",usertype)
	  const userstatus = [
		{ id: 0, c_name: "Actif" },
		{ id: 1, c_name: "Inactif" },
	  ];

	  const validateEmail = (email) => {
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return emailRegex.test(email);
	  };
	
	  const validatePassword = (password) => {
		return {
		  length: password.length >= 12,
		  uppercase: /[A-Z]/.test(password),
		  number: /\d/.test(password),
		  specialChar: /[~_!@#^()-+|.,]/.test(password),
		  restrictedChars: !/[&\/\\$%'"`=:;*?<>{}]/.test(password),
		};
	  };
	
	
	  const handleChange = (e) => {
		const { name, value } = e.target;
		
		setFormData((prevData) => ({
			...prevData,
			[name]: name === "c_password" && !value ? "" : value, // Keep existing password if blank
		}));
	
		// Validation Logic
		let newErrors = { ...errors };
	
		if (!value) {
			newErrors[name] = "هذه الخانة مطلوبه.";
		} else {
			delete newErrors[name];
		}
	
		if (name === "c_email" && !validateEmail(value)) {
			newErrors[name] = "تنسيق البريد الإلكتروني غير صالح.";
		}
	
		if (name === "c_password" && value) { // Only validate if password is entered
			const validations = validatePassword(value);
			if (!validations.length) newErrors[name] = "يجب أن تتكون كلمة المرور من 12 حرفًا على الأقل.";
			if (!validations.uppercase) newErrors[name] = "يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل.";
			if (!validations.number) newErrors[name] = "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل.";
			if (!validations.specialChar) newErrors[name] = "يجب أن تحتوي كلمة المرور على حرف خاص واحد على الأقل.";
			if (!validations.restrictedChars) newErrors[name] = "تحتوي كلمة المرور على أحرف مقيدة";
		}
	
		setErrors(newErrors);
	  };

	  
const handleChangeUserType = (e) => {
		const { name, value } = e.target;
		
		setFormData((prevData) => ({
			...prevData,
			[name]: name === "c_password" && !value ? "" : value, // Keep existing password if blank
		}));

		if(e.target.value > 0)
		{
         setOrganizationTypeList([]);
		}else
		{
		axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_organization_mst')},{ headers: { 'Content-Type': 'application/json' } }) 
	   .then( (res) => {
	   setOrganizationTypeList(res.data);
	   }).catch( (error) => { console.log(error); });
	}
	  };

	  const handleSubmit = async (e) => {
		e.preventDefault();
	   
		let newErrors = {};
		
		// Check for empty fields
		if (!editMode) {
		Object.keys(formData).forEach((key) => {
		  if (!formData[key]) {
			newErrors[key] = "هذه الخانة مطلوبه.";
		  }
		});
	} else {
		// Check for empty fields (except password in edit mode)
		Object.keys(formData).forEach((key) => {
			if (!formData[key] && key !== "c_password") { 
			  newErrors[key] = "هذه الخانة مطلوبه.";
			}
		  });
		}
		
		if (!editMode) {
		// Enforce password validation before submitting
		const validations = validatePassword(formData.c_password);
		if (!validations.length) newErrors["c_password"] = "يجب أن تتكون كلمة المرور من 12 حرفًا على الأقل.";
		if (!validations.uppercase) newErrors["c_password"] = "يجب أن تحتوي كلمة المرور على حرف كبير واحد على الأقل.";
		if (!validations.number) newErrors["c_password"] = "يجب أن تحتوي كلمة المرور على رقم واحد على الأقل.";
		if (!validations.specialChar) newErrors["c_password"] = "يجب أن تحتوي كلمة المرور على حرف خاص واحد على الأقل.";
		if (!validations.restrictedChars) newErrors["c_password"] = "تحتوي كلمة المرور على أحرف محظورة.";
		}

		if (!editMode) {
		// If there are validation errors, stop submission
		if (Object.keys(newErrors).length > 0) {
		  setErrors(newErrors);
		  return;
		}
	}
		console.log("formdata",formData)
		try {
		  console.log("formdata afeter",formData)
		  var response;
		  if (!editMode) {
			response = await axios.post(`${API_BASE_URL}/api/user/signup`, { data: formData });
			alert("تم حفظ البيانات بنجاح!");
			setEditMode(false);
			setSelectedUser(null);
			window.location.reload(); // Refresh DataTable
		  } else {
			response = await axios.put(`${API_BASE_URL}/api/user/updateuser`, { data: formData });
			alert("تم تحديث المستخدم بنجاح!");
			setEditMode(false);
			setSelectedUser(null);
			window.location.reload(); // Refresh DataTable
		  }
		   // Reset formData state
		   setFormData({
			c_name: "",
			c_username: "",
			c_email: "",
			c_password: "",
			n_phone_no: "",
			n_user_type: "",
			n_status: "",
			n_org_id :"",
			n_if_2fa_enabled :''
		  });	   
		 
		} catch (error) {
		  console.error("Error saving data:", error);
		}
	  };

	  const handleSubmitRaportee = async (e) => {
		 e.preventDefault();
		 var response = await axios.post(`${API_BASE_URL}/api/user/rapports/linkcreate`, { data: raporteedata },{ headers: { 'Content-Type': 'application/json' } });
		 if(response)
		 {		
		 alert("تم ربط المستخدم بنجاح");
		 }
		 setRapporteeData({
			n_stakeholder_id: ""
		  });
		  setSelectedUser(null);
		  window.location.reload(); // Refresh DataTable
	     };

		  const handleSubmitPermission = async (e) => {
		 e.preventDefault();
		 var response = await axios.post(`${API_BASE_URL}/api/user/permission/create`, { data: permission },{ headers: { 'Content-Type': 'application/json' } });
		 if(response)
		 {		
		 alert("تم تحديث الإذن بنجاح");
		 }
		 setPermissionData({
			n_master_id: ""
		  });
		  setSelectedUser(null);
		  window.location.reload(); // Refresh DataTable
	     };

	     const exportData = (type) => {
		 const ws = XLSX.utils.json_to_sheet(tabledata);
		 const wb = XLSX.utils.book_new();
		 XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
	
		 if (type === "csv") {
		  XLSX.writeFile(wb, "data_export.csv");
		} else {
		  XLSX.writeFile(wb, "data_export.xlsx");
		}
	  };
	
	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/page-option/blank">الصفحة الرئيسية</Link></li>
				<li className="breadcrumb-item"><Link to="/page-option/blank">الإدارة</Link></li>
				<li className="breadcrumb-item active">إدارة المستخدمين</li>
			</ol>
			<h1 className="page-header">الإدارة <small>إنشاء مستخدمين هنا</small></h1>
			<Panel>
				<PanelHeader>إنشاء مستخدمين هنا</PanelHeader>
				<PanelBody>
				<div className="row">
				<div className="col-xl-12">
				<ul className="nav nav-pills">
        <li className="nav-item">
          <a
            href="#default-tab-1"
            data-bs-toggle="tab"
            className={`nav-link ${activeTab === "default-tab-1" ? "active" : ""}`}
            onClick={() => setActiveTab("default-tab-1")}>
            <span className="d-sm-block d-none">قائمة المستخدمين</span>
          </a>
        </li>
        <li className="nav-item">
          <a
            href="#default-tab-2"
            data-bs-toggle="tab"
            className={`nav-link ${activeTab === "default-tab-2" ? "active" : ""}`}
            onClick={() => tabActive("default-tab-2")}
          >
            <span className="d-sm-block d-none">إضافة مستخدم جديد</span>
          </a>
        </li>
      </ul>
					<div className="tab-content panel rounded-0 p-3 m-0">
					<div className={`tab-pane fade ${activeTab === "default-tab-1" ? "active show" : ""}`} id="default-tab-1">
						<button onClick={() => exportData("xlsx")} className="btn btn-success">
								تصدير إلى إكسل
								</button>
							<DataTable
									title="بيانات المستخدم"
									columns={columns}
									data={tabledata}
									pagination
									highlightOnHover
								/>

								
						</div>
						<div className={`tab-pane fade ${activeTab === "default-tab-2" ? "active show" : ""}`} id="default-tab-2">
							<form method="post" onSubmit={handleSubmit}>
								{[
									{ label: "الاسم", name: "c_name", type: "text" },
									{ label: "اسم المستخدم", name: "c_username", type: "text" },
									{ label: "البريد الإلكتروني", name: "c_email", type: "email" },
									{ label: "كلمة المرور", name: "c_password", type: "password" },
									{ label: "رقم الاتصال", name: "n_phone_no", type: "number" },
								].map((field) => (
									<div className="row mb-15px" key={field.name}>
									<label className="form-label col-form-label col-md-3">{field.label}</label>
									<div className="col-md-9">
									{field.name === "c_password" && editMode ? (
									<input
									className="form-control mb-5px"
									type={field.type}
									name={field.name}
									placeholder="اتركه فارغًا إذا لم يتغير"        
									onChange={handleChange}
									/>
								) : (
									<input
									className="form-control mb-5px"
									type={field.type}
									name={field.name}
									value={formData[field.name]}
									onChange={handleChange}
									/>
								)}
										{errors[field.name] && <span style={{ color: "red" }}>{errors[field.name]}</span>}
									</div>
									</div>
								))}

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">نوع المستخدم</label>
									<div className="col-md-9">
									<select name="n_user_type" className="form-select" onChange={handleChangeUserType} value={formData.n_user_type}>
										<option value="">تحديد نوع المستخدم</option>
										{usertype.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_user_type && <span style={{ color: "red" }}>{errors.n_user_type}</span>}
									</div>
								</div>

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">يكتب</label>
									<div className="col-md-9">
									<select name="n_org_id" className="form-select" onChange={handleChange} value={formData.n_org_id}>
										<option value="">تحديد نوع المستخدم</option>
										{organizationtype.map((option) => (
										<option value={option.id} key={option.id}>{option.c_org_name}</option>
										))}
									</select>
									{errors.n_org_id && <span style={{ color: "red" }}>{errors.n_org_id}</span>}
									</div>
								</div>

								<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">حالة المستخدم</label>
									<div className="col-md-9">
									<select name="n_status" className="form-select" onChange={handleChange} value={formData.n_status}>
									<option value="">تحديد حالة المستخدم</option>
										{userstatus.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>
									{errors.n_status && <span style={{ color: "red" }}>{errors.n_status}</span>}
									</div>
								</div>

									<div className="row mb-15px">
									<label className="form-label col-form-label col-md-3">هل تم تفعيل 2FA؟</label>
									<div className="col-md-9">
									<select name="n_if_2fa_enabled" className="form-select" onChange={handleChange} value={formData.n_if_2fa_enabled}>
										<option value="">يختار</option>
										{yesno.map((option) => (
										<option value={option.id} key={option.id}>{option.c_name}</option>
										))}
									</select>									
									</div>
								</div>

							
                                {!editMode ?
								<button type="submit"  className="btn btn-success w-100px">Save</button>
								:
								<button type="submit" className="btn btn-success w-100px">Update</button> }
								</form>
						</div>
						
					</div>
					</div>
					
					</div>
				</PanelBody>
			</Panel>
			<div className="modal modal-pos fade" id="modalPosBooking">
				<div className="modal-dialog modal-lg" style={{maxWidth:"95%"}}>
					<div className="modal-content border-0">
						<div>
							<div className="p-0">
							<form onSubmit={handleSubmitRaportee}>								
    <div className="modal-body">
        <div className="d-flex align-items-center mb-3">
            <h4 className="modal-title d-flex align-items-center">
                <i className="fa fa-bowl-rice fs-2 me-2 my-n1"></i>
            </h4>
            <a href="/#" data-bs-dismiss="modal" onClick={closeModal} className="ms-auto btn-close">&nbsp;</a>
        </div>
        <div className="row">
            <div className="row mb-15px">
                <label className="form-label col-form-label col-md-3">التقارير الداخلية</label>
                <div className="col-md-9">
                    {/* Enable multi-select functionality */}
                    <select 
                        name="n_stakeholder_id"
                        className="form-select"
						style={{height:"500px"}}
                        multiple // Enables multi-selection
                        onChange={handleMultiSelectChange} 
                        value={Array.isArray(raporteedata.n_stakeholder_id) ? raporteedata.n_stakeholder_id : []}                    >
                        <option value="" disabled>تحديد التقرير الداخلي</option>
                        {internes.map((option) => (
                            <option value={option.id} key={option.id}>{option.c_name}</option>
                        ))}
                    </select>
                    
                </div>
            </div>
        </div>
    </div>
    <div className="modal-footer">									
        <button type="submit" className="btn btn-success w-100px">حفظ</button>
    </div>
</form>


							</div>
						</div>
					</div>
				</div>
			</div>
<div className="modal modal-pos fade" id="modalforUserpermission">
				<div className="modal-dialog modal-lg" style={{maxWidth:"95%"}}>
					<div className="modal-content border-0">
						<div>
							<div className="p-0">
							<form onSubmit={handleSubmitPermission}>								
    <div className="modal-body">
        <div className="d-flex align-items-center mb-3">
            <h4 className="modal-title d-flex align-items-center">
                <i className="fa fa-bowl-rice fs-2 me-2 my-n1"></i>
            </h4>
            <a href="/#" data-bs-dismiss="modal" onClick={closeModal} className="ms-auto btn-close">&nbsp;</a>
        </div>
        <div className="row">
            <div className="row mb-15px">
                <label className="form-label col-form-label col-md-3">تعيين إذن المستخدم</label>
                <div className="col-md-9">
                    {/* Enable multi-select functionality */}
                    <select 
                        name="n_master_id"
                        className="form-select"
						style={{height:"300px"}}
                        multiple // Enables multi-selection
                        onChange={handlePermissionChange} 
                        value={Array.isArray(permission.n_master_id) ? permission.n_master_id : []}                    >
                        <option value="" disabled>تحديد التقرير الداخلي</option>
                        {permissionmodules.map((option) => (
                            <option value={option.id} key={option.id}>{option.c_name}</option>
                        ))}
                    </select>
                    
                </div>
            </div>
        </div>
    </div>
    <div className="modal-footer">									
        <button type="submit" className="btn btn-success w-100px">حفظ</button>
    </div>
</form>


							</div>
						</div>
					</div>
				</div>
			</div>

			
		</div>
	)
}

export default Usermanage;